import React from 'react'
import { useContext } from './Context'
import { RadioInput } from '@ztechapps/webui.input'
import { HorizontalStack } from '@ztechapps/webui.util'

export const TypeValue = () => {
  const { valueType, setValueType } = useContext()

  return (
    <HorizontalStack gap={3}>
      <RadioInput
        name="valueType"
        label={'Date'}
        checked={valueType === 'date'}
        onChange={() => setValueType('date')}
      />
      <RadioInput
        name="valueType"
        label={'Dynamic'}
        checked={valueType === 'dynamic'}
        onChange={() => setValueType('dynamic')}
      />
    </HorizontalStack>
  )
}
